import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=3bfe896d&scoped=true&"
import script from "./videoBox.vue?vue&type=script&lang=js&"
export * from "./videoBox.vue?vue&type=script&lang=js&"
import style0 from "./videoBox.vue?vue&type=style&index=0&id=3bfe896d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe896d",
  null
  
)

export default component.exports